import { useHistory } from 'react-router-dom';
import { t, jt } from 'ttag';

import SwapLogoIcon from '@svg/swap-logo.svg';
import { swapLanding } from '@urls';
import { Link } from '@ui/Link';

import s from './ProductDetailsSwapBanner.sss';

export const ProductDetailsSwapBanner = () => {
  const history = useHistory();

  const landingLink = (
    <Link
      className={s.link}
      href={history.createHref({ pathname: swapLanding })}
    >
      {t`Детальніше`}
    </Link>
  );

  return (
    <div className={s.root}>
      <SwapLogoIcon
        className={s.icon}
        width="24"
        height="24"
      />

      <p className={s.description}>
        {jt`Віддай своє, вибери нове ${landingLink}`}
      </p>
    </div>
  );
};
